import { __decorate } from "tslib";
import { singleton } from 'mana-syringe';
import { GeometryAABBUpdater } from './interfaces';
import { Shape } from '../../types';

var EllipseUpdater =
/** @class */
function () {
  function EllipseUpdater() {}

  EllipseUpdater.prototype.update = function (parsedStyle, object) {
    var rx = parsedStyle.rx,
        ry = parsedStyle.ry,
        _a = parsedStyle.x,
        x = _a === void 0 ? 0 : _a,
        _b = parsedStyle.y,
        y = _b === void 0 ? 0 : _b;
    var rxUnit = rx.unit,
        rxValue = rx.value;
    var ryUnit = ry.unit,
        ryValue = ry.value;
    var width = 0;
    var height = 0;

    if (rxUnit === '' || rxUnit === 'px') {
      width = rxValue * 2;
    }

    if (ryUnit === '' || ryUnit === 'px') {
      height = ryValue * 2;
    }

    object.parsedStyle.rxInPixels = width / 2;
    object.parsedStyle.ryInPixels = height / 2;
    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  };

  EllipseUpdater = __decorate([singleton({
    token: {
      token: GeometryAABBUpdater,
      named: Shape.ELLIPSE
    }
  })], EllipseUpdater);
  return EllipseUpdater;
}();

export { EllipseUpdater };